module.exports = __webpack_public_path__ + "img/Tessellate00.0f19c0bf.jpg";